<template>
  <div class="item-slot">
    <img loading="lazy" sizes="100%, 100%" class="icon-image" :src="selectedItemPreview" :class="`item-${this.selectedItem.id}`"
         :alt="ucFirst(this.selectedItem.name)"
         :title="ucFirst(this.selectedItem.name)" @click="showItemSearch">
    <ItemSearch :items="items" ref="itemSearch" @selected="itemSelected"></ItemSearch>
  </div>
</template>

<script>
  import ItemSearch from "./ItemSearch";

  export default {
    name: "InventorySlot",
    components: {ItemSearch},
    props: {
      id: {
        type: Number,
        default: 0,
      },
      itemSlot: {
        type: String,
        required: true,
      },
      selectedItem: {
        type: Object,
      },
      items: {
        type: Array,
        required: true,
      },
      defaultItem: {
        type: Object,
        default: function () {
          return {
            "id": 229,
            "name": "Empty",
            "icon": "iVBORw0KGgoAAAANSUhEUgAAACQAAAAgCAYAAAB6kdqOAAAC/klEQVR4Xt2XW08aURSFPf/E9KE1bU1MvSMK4gVBUEBBERURQVCQq9yTNmmaNOlP6EvTh6axaZqqbdJftzp7T884jH2pgUPSnayETAjzZZ119t4MDf0fJdCtgZbAq6oNxfQEjiLP4Vt5NGgogV+fI/j5Kcx699KJWm56kFDCgLn+GMLbjgOV7CQDjQ0Pq4bSMyOBvn0I4k1zno9vAHkS2Nk9QCwWN9z58n4Dr+t25JMvsLS0BrfbrxJK4DiZvqfIzj6CwR2s+4KYX3CpPDqB89wFK2dSOBLDZiAMl8uN8XE93MqAqtWaoXK5imKxjK3tKFbdPszM2DEy8kwlEJXA1dVX3N7+wM3NLb5f3/BxLTiWjFATjFKgTOYczWYLnU6HRcflXFwZBAyVQKlURqvVZrXbbSM/io9KlmB3WC1ddGTLyx5MTdlUXnkqgfxFEY1Gs0sy1LOz8ypdEkgcp1CvNzQIqSYSiRQi2rX3ejdhtzsxOTmryiWBQqFkAWowZDR6CJ8/BIdzma++ApcEkslTXF7WGMgseh7bP8LG5jYHW5FLAhdadmq1epcI6OTkFIeHxwiFtGCveLkf9dklgVQqg0qleg+IlEpnED9KYju8h7U1PxZdq5ibc2BiYqZfLgmeV3RcJCtQOp3lYNMW4F0PGC5NT8/1wyXBDlAjlEBmEdCp1rUp2Ht7cfj9W7x+9NElbbqf57sGqpSEojFCwd4/SCAQiPD1pyZJa0iPXdJvFl31SvXSkBUsm81xsOPxJEJbu4ZLNNtstgUNSg+49dcfUPoQpTCzTFBmOHJQBlvuRWaX5DjpgUv6mKCdx4Ay6w8ULWsy2LvRA3aJmiSNEumSXNqsb3hACQYyywqWzxeMYNOuLV3yeDb4to2OjhkO9cSlYrHEWyGJblupVGFJQHJRBpsaJA1agqGO/fjJ017CyNK3QOrUFHAJKOHouQw2HRc1R3m7+gCjl/6D8j+XPmQlGH0+O8sbo8MK0nMYc9294A7OKiUgfyvzi62yfvdf6zfFhwglCbYCwgAAAABJRU5ErkJggg=="
          }
        }
      }
    },
    data() {
      return {
        showSearch: false,
        originalItems: null,
      }
    },
    computed: {
      selectedItemPreview: function () {
        if (!this.selectedItem.hasOwnProperty('icon') || this.selectedItem.icon === '')
          return `data:image/jpeg;base64,${this.defaultItem.icon}`;

        return `data:image/jpeg;base64,${this.selectedItem.icon}`
      },
    },
    methods: {
      showItemSearch: function () {
        this.$refs.itemSearch.showSearch();
      },

      hideItemSearch: function () {
        this.$refs.itemSearch.hideSearch();
      },

      itemSelected: function (item) {
        console.log('inventory item selected', item);
        this.hideItemSearch();

        this.$emit('update', this.itemSlot, item);
      }
    }
  }
</script>

<style scoped>
  .item-slot {
    /*height: 100%;*/
    /*width: 100%;*/

    /*border: 1px solid rgba(0, 0, 0, 0.125);*/
    /*border-radius: 3px;*/

    cursor: pointer;
  }

  .icon-image {
    /*display: block;*/
    /*margin-left: auto;*/
    /*margin-right: auto;*/
    /*transform: scale(1.4);*/
    /*height: 100%;*/
    /*width: 90%;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/InventorySlot.vue